var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.32 5.04981L15.32 3.04981H15.25C15.2035 3.04513 15.1566 3.04513 15.11 3.04981H14.88H14.75H14.68L9 4.99981L3.32 3.04981C3.16962 3.00022 3.00961 2.98706 2.85314 3.0114C2.69667 3.03573 2.54822 3.09688 2.42 3.18981C2.29076 3.28183 2.18527 3.40327 2.11224 3.54412C2.03921 3.68496 2.00074 3.84116 2 3.99981V17.9998C1.99946 18.2095 2.06482 18.414 2.18685 18.5844C2.30887 18.7549 2.48138 18.8827 2.68 18.9498L8.68 20.9498C8.88145 21.0155 9.09856 21.0155 9.3 20.9498L15 19.0498L20.68 20.9998C20.7862 21.0142 20.8938 21.0142 21 20.9998C21.2091 21.0028 21.4132 20.9359 21.58 20.8098C21.7092 20.7178 21.8147 20.5963 21.8878 20.4555C21.9608 20.3147 21.9993 20.1585 22 19.9998V5.99981C22.0005 5.79017 21.9352 5.58565 21.8132 5.41518C21.6911 5.24471 21.5186 5.1169 21.32 5.04981ZM8 18.6098L4 17.2798V5.38981L8 6.71981V18.6098ZM14 17.2798L10 18.6098V6.71981L14 5.38981V17.2798ZM20 18.6098L16 17.2798V5.38981L20 6.71981V18.6098Z",
    fill: "#6F6F6F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.96800983e8f5f4eebc1069dbb141075c.svg";
export { ForwardRef as ReactComponent };